import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import ArrowRight from '@deliveroo/icon-set/react/ArrowRight';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import P from '@deliveroo/consumer-component-library/components/P';
import MobileBanner from '../MobileBanner';
import styles from './MobileInviteBanner.scss';

/**
 * A CTA banner displayed on mobile web to customers eligible for the Member-get-Member offer
 */
export default function MobileInviteBanner({ isDismissed, bodyText, linkText, onClose, onClick }) {
  const renderWrapper = (children) => <div className={styles.wrapper}>{children}</div>;
  const renderIcon = () => <div className={styles.fistBump} />;
  const renderBody = () => (
    <Fragment>
      <button type="button" className={styles.ctaButton} onClick={onClick}>
        <P color="white" size="small">
          {bodyText}
        </P>
        <P color="white" size="small" isBold spacing="x-small 0 0">
          {linkText} <Icon component={ArrowRight} size={18} />
        </P>
      </button>
    </Fragment>
  );

  return (
    <MobileBanner
      isDismissed={isDismissed}
      renderWrapper={renderWrapper}
      renderImage={renderIcon}
      renderBody={renderBody}
      onClose={onClose}
    />
  );
}

MobileInviteBanner.propTypes = {
  /**
   * Is the banner dismissed?
   */
  isDismissed: PropTypes.bool.isRequired,

  /**
   * String to display as the body of the banner.
   */
  bodyText: PropTypes.string.isRequired,

  /**
   * String to display as a link within the banner.
   */
  linkText: PropTypes.string.isRequired,

  /**
   * Event handler for when the banner is closed.
   */
  onClose: PropTypes.func.isRequired,

  /**
   * Event handler for when the banner is clicked.
   */
  onClick: PropTypes.func.isRequired,
};
